import type { PropsWithChildren } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { MainContainer } from '@/components/GlobalComponents';
import { colors } from '@/styles/theme/foundations/colors';
import { STATUS_PAGE_URL } from '../../modules/link';

interface Props extends PropsWithChildren {
  authContainerWidth?: string;
}

export default function LoginLayout({ children, authContainerWidth = '438px' }: Props) {
  return (
    <MainContainer
      className="main-container"
      direction="column"
      minHeight="100vh"
      variant="main"
      backgroundColor={colors.background.page.dark}
    >
      <Head>
        <title>Nabis - Sign in</title>
        <meta name="description" content="Nabis - Sign in" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Box w="100%" h="100%" backgroundColor={colors.background.global.dark}>
        <Flex
          position={'absolute'}
          flexDirection={'column'}
          top={'calc(50% - 385px / 2 + 0.5px)'}
          w={authContainerWidth}
          left={`calc(50% - ${authContainerWidth} / 2)`}
        >
          <Image src="/nabis-logo-sign.svg" width="35" height="35" alt="logo-sign" priority />
          {children}
        </Flex>
        <Flex position={'fixed'} bottom={6} width={'100%'} justifyContent={'center'}>
          <Text variant="secondary" fontSize={12} padding={'0 12px'}>
            © {new Date().getFullYear()} Nabis
          </Text>
          <Link
            href={STATUS_PAGE_URL}
            borderLeft={`1px solid ${colors.border.opaque.light}`}
            borderRight={`1px solid ${colors.border.opaque.light}`}
          >
            <Text variant="secondary" fontSize={12} padding={'0 12px'}>
              System Status
            </Text>
          </Link>
          <Text
            variant="secondary"
            fontSize={12}
            padding={'0 12px'}
            as={Link}
            href="https://www.nabis.com/legal/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </Text>
        </Flex>
      </Box>
    </MainContainer>
  );
}
